module.exports = __webpack_public_path__ + "static/media/KnowBe4-10.a9024437.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/files/KnowBe4-10.pdf
// module id = 108
// module chunks = 0